import dynamic from "next/dynamic";
import BottomLogosConfig from "./bottom-logos-config";
import BottomLogosAdvancedConfig from "./bottom-logos-advanced-config";
const BottomLogosComponent = dynamic(()=>import("./bottom-logos-component"));
export default {
    BottomLogosComponent,
    BottomLogosConfig,
    BottomLogosAdvancedConfig
};
